import {
  Comm,
  CommSetCopyProps,
} from "../components/communications/CommunicationSetEditor";
import Anchor from "../models/anchors/Anchor";
import Communication from "../models/communications/Communication";
import CommunicationSet from "../models/communications/CommunicationSet";
import Interval from "../models/communications/Interval";
import IntervalSet from "../models/communications/IntervalSet";
import Interaction from "../models/interactions/Interaction";
import InteractionNode from "../models/interactions/InteractionNode";
import InteractionNodeInteraction from "../models/interactions/InteractionNodeInteraction";
import InteractionNodeInterval from "../models/interactions/InteractionNodeInterval";
import InteractionParentInterval from "../models/interactions/InteractionParentInterval";

// This is probably unique/random enough for our purposes?
export function guidGenerator() {
  return Date.now() + Math.floor(Math.random() * 1000);
}

// this really isnt used right now
// if it ends up being utilized, we need to update the code to adjust item.type and item.props for Mark's db changes
export function interactionsAndNodesListToModels(
  interactionsAndNodesList: Array<InteractionNodeInteraction>,
) {
  return interactionsAndNodesList.map((item) => {
    return new InteractionNodeInteraction(
      item.interaction_node_id,
      item.set,
      item.parent,
      item.ordinal,
      item.child,
      item.condition_id,
      item.interaction_id,
      item.type,
      item.title,
      item.title + ": - Interaction # " + item.interaction_id,
      item.properties,
    );
  });
}

// returns a serializable array for Redux state
// (but runs eveything through the propietary modeling just to make sure things are as they should)
export function interactionsNodesHandleFetch(
  interactionNodes: Array<InteractionNode>,
) {
  const transformedInteractionNodes: Array<InteractionNode> =
    interactionNodes.map((item) => {
      return new InteractionNode(
        item.id,
        item.set_interaction_id,
        item.parent_interaction_id,
        item.ordinal,
        item.child_interaction_id,
        item.condition_id,
        item.modified,
      );
    });
  return stateDeepCopy(transformedInteractionNodes);
}

// returns a serializable array for Redux state
// (but runs eveything through the propietary modeling just to make sure things are as they should)
export function interactionNodeIntervalsHandleFetch(
  interactionNodes: Array<InteractionNodeInterval>,
) {
  const transformedInteractionNodeIntervals: Array<InteractionNodeInterval> =
    interactionNodes.map((item) => {
      return new InteractionNodeInterval(
        item.id,
        item.interaction_node_id,
        item.interval_id,
        item.condition_id,
        item.communication_set_id,
        item.target,
        item.modified,
      );
    });
  return stateDeepCopy(transformedInteractionNodeIntervals);
}

// returns a serializable array for Redux state
// (but runs eveything through the propietary modeling just to make sure things are as they should)
export function intervalsHandleFetch(interactionNodes: Array<Interval>) {
  const transformedIntervals: Array<Interval> = interactionNodes.map((item) => {
    return new Interval(
      item.id,
      item.interval_set_id,
      item.name,
      item.start_day,
      item.end_day,
      item.communication_set_id,
      item.modified,
    );
  });
  return stateDeepCopy(transformedIntervals);
}
// returns a serializable array for Redux state
// (but runs eveything through the propietary modeling just to make sure things are as they should)
export function intervalSetsHandleFetch(interactionNodes: Array<IntervalSet>) {
  const transformedIntervalSets: Array<IntervalSet> = interactionNodes.map(
    (item) => {
      return new IntervalSet(
        item.id,
        item.name,
        item.shared,
        item.modified,
      );
    },
  );
  return stateDeepCopy(transformedIntervalSets);
}

// returns a serializable array for Redux state
// (but runs eveything through the propietary modeling just to make sure things are as they should)
export function communicationSetsHandleFetch(
  communicationSets: Array<CommunicationSet>,
) {
  const transformedCommunicationSets: Array<CommunicationSet> =
    communicationSets.map((item) => {
      return new CommunicationSet(item.id, item.name, item.modified);
    });
  return stateDeepCopy(transformedCommunicationSets);
}

// returns a serializable array for Redux state
// (but runs eveything through the propietary modeling just to make sure things are as they should)
// TEMPORARY - TRANSFORM OLD VERSION OF COMM INTO NEW
export function communicationsHandleFetchsHandleFetch(
  communications: Array<any>,
) {
  // once db and UI are in sync, Array<any> can be Array<Communication>
  const transformedCommunications: Array<Communication> = communications.map(
    (item) => {
      // TEMPORARY - TRANSFORM OLD VERSION OF COMM INTO NEW
      // let properties: CommunicationSettings = new CommunicationSettings(item.type,item.priority,item.medium,item.notification_minimum_frequency,item.subject,item.message)
      // return new Interaction(item.id, item.title, item.properties, item.modified)
      return new Communication(
        item.id,
        item.communication_set_id,
        item.start,
        item.end,
        item.properties,
        item.modified,
      );
    },
  );
  return stateDeepCopy(transformedCommunications);
}

export function communicationsCopyHandleFetchsHandleFetch(
  commSetCopyProps: CommSetCopyProps,
) {
  // once db and UI are in sync, Array<any> can be Array<Communication>
  const transformedCommunications: Array<Communication> =
    commSetCopyProps.comms.map((item: Comm) => {
      // TEMPORARY - TRANSFORM OLD VERSION OF COMM INTO NEW
      // let properties: CommunicationSettings = new CommunicationSettings(item.type,item.priority,item.medium,item.notification_minimum_frequency,item.subject,item.message)
      // return new Interaction(item.id, item.title, item.properties, item.modified)
      return new Communication(
        item.comm_id,
        item.comm_set_id,
        item.start,
        item.end,
        item.properties,
        "2023-04-20T17:10:22.063963",
      );
    });
  return stateDeepCopy(transformedCommunications);
}

// returns a serializable array for Redux state
// (but runs eveything through the propietary modeling just to make sure things are as they should)
export function interactionParentIntervalsHandleFetch(
  interactionParentIntervals: Array<InteractionParentInterval>,
) {
  const transformedInteractionParentIntervals: Array<InteractionParentInterval> =
    interactionParentIntervals.map((item) => {
      return new InteractionParentInterval(
        item.id,
        item.interaction_parent_id,
        item.interval_id,
        item.communication_set_id,
        item.modified,
      );
    });
  return stateDeepCopy(transformedInteractionParentIntervals);
}

export function anchorsHandleFetch(anchors: Array<Anchor>) {
  const transformedAnchors: Array<Anchor> = anchors.map((item) => {
    return new Anchor(
      item.id,
      item.subject_id,
      item.interaction_id,
      item.date,
      item.properties,
    );
  });
  return stateDeepCopy(transformedAnchors);
}

export function stateDeepCopy(state: any) {
  const stateDeepCopy = JSON.parse(JSON.stringify(state)); // make a deep copy so we're not mutating original state refs
  return stateDeepCopy;
}

export function arrayContainsObject(obj: any, array: any) {
  let i;
  for (i = 0; i < array.length; i++) {
    if (array[i] === obj) {
      return true;
    }
  }

  return false;
}

export function getAllIndexes(arr: any, val: any) {
  const indexes = [];
  let i;
  for (i = 0; i < arr.length; i++) if (arr[i] === val) indexes.push(i);
  return indexes;
}

export function compareIntervals(a: any, b: any) {
  if (a.communication_set_id < b.communication_set_id) {
    return 1;
  }

  if (a.communication_set_id > b.communication_set_id) {
    return -1;
  }


  if (a.start_day < b.start_day) {
    return -1;
  }
  if (a.start_day > b.start_day) {
    return 1;
  }
  return 0;
}

export function compareIntervalsByDay(a: any, b: any) {
  if (a.start_day < b.start_day) {
    return -1;
  }
  if (a.start_day > b.start_day) {
    return 1;
  }
  return 0;
}

export function sortIntervalsByCommunicationAndStartDay(array: Array<any>) {
  const doIntervalsHaveCommSet = _doIntervalsHaveCommSet(array)
  // if any of the intervals do have a commset attached, we want to consider that when sorting
  if(doIntervalsHaveCommSet){
    return array.sort((a, b) => {
      // Sort by communication_set_id ascending
      if (a.communication_set_id === null && b.communication_set_id !== null) {
        return 1; // `a` should come after `b`
      } else if (a.communication_set_id !== null && b.communication_set_id === null) {
        return -1; // `a` should come before `b`
      } else {
        // If both have the same communication_set_id or both are null, sort by start_day ascending
        if (a.communication_set_id === b.communication_set_id) {
          return a.start_day - b.start_day;
        }
        return a.communication_set_id - b.communication_set_id;
      }
    });
  // if none of the intervals have any commset assigned,
  // just order them by startDay ascending
  } else {
    return array.sort((a, b) => a.start_day - b.start_day);
  }

}

// helper that checks to see if any intervals at all 
// have a non-null commset assigned.
// If a set of intervals has no commsets among them,
// we dont need to try grouping them by commset
function _doIntervalsHaveCommSet(array: Array<Interval>){
  for(let i = 0; i < array.length; i++){
    if(array[i].communication_set_id !== null){
      return true
    }
  }
  return false;
}

export function compareInteractionNodesByOrdinality(a: any, b: any) {
  if (a.ordinal < b.ordinal) {
    return -1;
  }
  if (a.ordinal > b.ordinal) {
    return 1;
  }
  return 0;
}

export function compareCommunications(a: any, b: any) {
  const aPriority = _convertPriorityToNumericValues(a.properties.priority)
  const bPriority = _convertPriorityToNumericValues(b.properties.priority)

  if (parseInt(a.start) >= 0 && parseInt(b.start) < 0) {
    return -1;
  }
  if (parseInt(a.start) < 0 && parseInt(b.start) >= 0) {
    return 1;
  }
  if (parseInt(a.start) < parseInt(b.start)) {
    return -1;
  }
  if (parseInt(a.start) > parseInt(b.start)) {
    return 1;
  }
  if (aPriority < bPriority) {
    return -1;
  }
  if (aPriority > bPriority) {
    return 1;
  }
  return 0;
}

// convert priorities to numeric values to assist sorting
function _convertPriorityToNumericValues(priority:string){
  switch(priority){
    case 'first communication important':
      return 5;
    case 'last chance':
      return 4;
    case 'first reminder important':
      return 3;
    case 'first communication long term followup':
      return 2;
    case 'gentle reminder':
      return 1;
    default:
      return 1;
  }
}

export function getLastOrdinalFromNodes(a: Array<InteractionNode>) {
  if (a.length > 0) {
    a.sort(compareInteractionNodesByOrdinality);
    const lastNode = a[a.length - 1];
    const ordinal = lastNode.ordinal;
    return ordinal;
  } else {
    return 1;
  }
}

export function getFirstOrdinalFromNodes(a: Array<InteractionNode>) {
  if (a.length > 0) {
    a.sort(compareInteractionNodesByOrdinality);
    const firstNode = a[0];
    const ordinal = firstNode.ordinal;
    return ordinal;
  } else {
    return 0;
  }
}

export function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}
export function compareInteractionsByTitle(a: any, b: any) {
  if (a.title < b.title) {
    return -1;
  }
  if (a.title > b.title) {
    return 1;
  }
  return 0;
}

// useful for handling comm startday
export function extractNumbersFromString(inputString: string) {
  const regex = /\d+/g;
  const numbersArray = inputString.match(regex);
  return numbersArray ? numbersArray.map(Number) : [];
}

export function camelCaseToSpaceDelimited(camelCaseString: string) {
  // Use regular expression to split camelCaseString into an array
  const wordsArray = camelCaseString.split(/(?=[A-Z])/);

  // Join the array with space to create the space-delimited string
  const spaceDelimitedString = wordsArray.join(" ");

  return spaceDelimitedString;
}


export function uniqueBy(arr:any, prop:any) {
  const seen = new Map();
  return arr.filter((item:any) => {
    const key = prop ? item[prop] : item;
    if (!seen.has(key)) {
      seen.set(key, true);
      return true;
    }
    return false;
  });
}


export const buildMinimumNotificationFrequencyMetric = (minimum_notification_frequency: string, unit: string | null | undefined) => {
    
  if(typeof unit === "undefined" || !unit){
    unit = ""
  }
  if (unit == "Days") {
    unit = "days";
  } else if (unit == "Percent") {
    unit = "%";
  }
  const integer = sanitizeMinimumNotificationFrequency(minimum_notification_frequency)
  const returnString = integer + unit

  return returnString;
};

export const sanitizeMinimumNotificationFrequency = (minimum_notification_frequency: string) =>{
  const regex = /\d+/g; // This regex matches one or more digits
  const integers = minimum_notification_frequency.match(regex);
  return integers && integers.length > 0 ? integers[0] : 0; // return first/only number found

}

export function toLowerCaseObject(obj:object) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key.toLowerCase(),
      typeof value === 'string' ? value.toLowerCase() : value
    ])
  );
}

export function checkMatchingSubsequences(string1: string, string2: string): boolean {
  // Helper function to extract numbers following 's' or 'p'
  function extractNumbers(str: string, parentOnly: boolean): Array<string> {
    const regex = parentOnly ? /([p])(\d+)/g : /([sp])(\d+)/g;
    const results = [];
    let match: RegExpExecArray | null;

    while ((match = regex.exec(str)) !== null) {
      const value: string = match[2];
      results.push(value);
    }
    return results;
  }

  // Extract numbers after 's' or 'p' from both strings
  const numbersInString1: Array<string> = extractNumbers(string1, false);
  //console.log(numbersInString1)
  // only pull value from p in second string
  const numbersInString2: Array<string> = extractNumbers(string2, true);
  //console.log(numbersInString2)
  return numbersInString1.some(element => numbersInString2.includes(element));
}